<template>
  <div class="crop-breed-list-container">
    <wh-mobile-list
      ref="cropBreedList"
      class="crop-breed-list"
      :extra-params="extraParams"
      data-src="/api/getControlCropBreedList"
    >
      <template v-slot="{list}">
        <div
          v-for="(item,key) in list"
          :key="key"
          class="crop-breed-item"
        >
          <crop-breed-list-item
            :crop-breed-item="item"
            :land-id="landId"
            @editCropBreedItem="editCropBreedItem"
            @plantOption="plantOption"
            @refreshItem="refreshItem"
          />
        </div>
        <div class="create-plot">
          <van-button icon="plus" size="small" block color="create-plot-btn" native-type="button" type="info" @click="addPlotCrop">
            新增种养品种
          </van-button>
        </div>
      </template>
    </wh-mobile-list>
    <plant-popup
      :visible.sync="popup.plant.visible"
      :form-type="popup.plant.formType"
      :land-id="popup.plant.landId"
      :company-id="popup.plant.companyId"
      :init-form-data="popup.plant.initFormData"
      @submitFormSuccess="resetControlCropBreedList"
    />
    <pick-popup
      :visible.sync="popup.pick.visible"
      :form-type="popup.pick.formType"
      :init-form-data="popup.pick.initFormData"
      @submitFormSuccess="resetControlCropBreedList"
    />
    <crop-end-popup
      :visible.sync="popup.cropEnd.visible"
      :init-form-data="popup.cropEnd.initFormData"
      @submitFormSuccess="resetControlCropBreedList"
    />
  </div>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import { formatTime } from '@/utils/convert/convertTime'
import PlantPopup from '@/views/productManage/components/PlantPopup'
import CropBreedListItem from '@/views/productManage/PlotDetail/CropBreedList/CropBreedListItem'
import PickPopup from '@/views/productManage/components/PickPopup'
import CropEndPopup from '@/views/productManage/PlotDetail/CropBreedList/CropEndPopup'

export default {
  name: 'CropBreedList',
  components: { CropEndPopup, PickPopup, CropBreedListItem, PlantPopup, WhMobileList },
  props: {
    // 通过绑定 route.query 传递
    landId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      extraParams: {
        landId: this.landId
      },
      popup: {
        plant: {
          visible: false,
          landId: this.landId,
          initFormData: {},
          companyId: this.$store.getters.companyId,
          formType: 'create'
        },
        pick: {
          visible: false,
          initFormData: {},
          formType: 'create'
        },
        cropEnd: {
          visible: false,
          initFormData: {}
        }
      }
    }
  },
  methods: {
    formatTime,
    addPlotCrop() {
      this.popup.plant.formType = 'create'
      this.popup.plant.visible = true
    },
    async resetControlCropBreedList() {
      this.$refs.cropBreedList.onRefresh()
    },
    refreshItem(flag) {
      if (flag === 'close') {
        this.resetControlCropBreedList()
      }
    },
    transplant(item) {
      this.popup.plant.formType = 'transplant'
      this.popup.plant.visible = true
      this.popup.plant.initFormData = item
    },
    plantOption(text, item) {
      switch (text) {
        case '采收':
        case '出栏':
        case '捕捞':
          this.popup.pick.formType = 'create'
          this.popup.pick.visible = true
          this.popup.pick.initFormData = item
          break
        case '移栽':
          this.transplant(item)
          break
        case '种植结束':
          this.popup.cropEnd.visible = true
          this.popup.cropEnd.initFormData = item
          break
      }
    },
    editCropBreedItem(item) {
      this.popup.plant.formType = 'edit'
      this.popup.plant.visible = true
      this.popup.plant.initFormData = item
    }

  }
}
</script>

<style lang='less' scoped>
.crop-breed-list-container {
  height: 100%;
}
.crop-breed-list {
  background: #f3f7f8;
}
.create-plot {
  text-align: center;
  margin: 20px 20px 0 20px;
  .create-plot-btn {
  }
}
</style>
